module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"reviews_one":"оценка","reviews_few":"оценки","reviews_many":"оценок","comments_one":"отзыв","comments_few":"отзыва","comments_many":"отзывов"}}')
  delete Component.options._Ctor
}
